module.exports = __webpack_public_path__ + "16f34724e15eb1c9bb3c0e168b607aa0.pdf";